var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"96"}},[_vm._v("broken_image")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }